import { useCallback } from 'react';
import { map } from 'lodash';

import { isBrandTermActive } from 'src/data/brandTerm';
import { isSameLanguage } from 'src/data/generation';
import { useBrandTermsActions, useBrandVoicesAssets, useProjectActions } from 'src/store';
import { useBrandVocabularyPopup } from 'src/views/BrandVocabularyPopup';

export const useSetupProjectVocabulary = ({ language }) => {
  const openBrandTermSetsPopup = useBrandVocabularyPopup();
  const brandTermsActions = useBrandTermsActions();
  const projectActions = useProjectActions();
  const { brandVoicesAssets } = useBrandVoicesAssets();

  return useCallback(() => {
    const isSameLanguageCheck = (brandVoiceIdsForBrandTerms) => {
      const firstSelectedBrandVoice = brandVoicesAssets.find((brandVoice) =>
        brandVoiceIdsForBrandTerms.includes(brandVoice.id)
      );
      return isSameLanguage(language, firstSelectedBrandVoice?.language);
    };

    // Helper to handle popup close
    const handlePopupClose = (selectedBrandVoiceIds) => {
      if (!selectedBrandVoiceIds) return;

      // Update brand terms for UI
      brandTermsActions.setBrandVoiceIdsForBrandTerms(selectedBrandVoiceIds);

      // Update project data for future sessions
      const currentProject = projectActions.getCurrentProject();
      if (currentProject) {
        projectActions
          .updateProjectBrandVoicesForBrandTerms({
            id: currentProject.id,
            brandVoiceIds: selectedBrandVoiceIds,
          })
          .catch(() => {
            // No need to handle failure
          });
      }
    };

    const brandVoiceIdsForBrandTerms = brandTermsActions.getBrandVoiceIdsForBrandTerms();

    const brandVoiceIds = isSameLanguageCheck(brandVoiceIdsForBrandTerms)
      ? brandVoiceIdsForBrandTerms
      : map(
          brandVoicesAssets.filter(
            (brandVoice) =>
              isSameLanguage(brandVoice.language, language) &&
              brandVoice.brandTerms?.some(isBrandTermActive)
          ),
          'id'
        );

    openBrandTermSetsPopup({
      brandVoiceIds,
      language,
      onClose: handlePopupClose,
    });
  }, [brandTermsActions, openBrandTermSetsPopup, projectActions, language, brandVoicesAssets]);
};
